<template>
  <div class="axj-station">
    <station-header/>
    <station-main
      @create="handleCreateStation"
      @associationReplace="initAssociationPost"
      @edit="handleEditStation"
      @show="handleShowStation"
      @delete="handleDeleteStationPost"
      :association-posts="AssociationPosts" :associations="AssociationList"/>
    <station-footer/>
    <station-edit
      @success="handleEditStationSuccess"
      :is-create="StationEdit.isCreate"
      :show.sync="StationEdit.show"
      :stationId="StationEdit.stationId"
    />
  </div>
</template>

<script>
import StationHeader from "./component/station-header/index";
import StationMain from "./component/station-main/index";
import StationFooter from "./component/station-footer/index";

import {fetchAssociationList,fetchAssociationThreadList,deleteAssociationThread} from "../../../api/axj-information/axj-information-association"
import StationEdit from "./action/station-edit";
export default {
  name: "axj-station",
  components: {StationEdit, StationFooter, StationMain, StationHeader},
  methods:{
    handleDeleteStationPost(row){
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        deleteAssociationThread(row.id).then(res=>{
          this.initAssociationPost(row.association_id)
        },error => {

        })
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    async handleEditStationSuccess(){
      await this.initAssociation()
      this.StationEdit.show=false
    },
    async initData(){
      await this.initAssociation()
      await this.initAssociationPost(this.AssociationList[0].id)
    },
    handleShowStation(id){
      this.StationEdit.stationId=id
      this.StationEdit.isCreate=2
      this.StationEdit.show=true
    },
    handleEditStation(id){
      this.StationEdit.stationId=id
      this.StationEdit.isCreate=1
      this.StationEdit.show=true
    },
    handleCreateStation(){
      this.StationEdit.isCreate=0
      this.StationEdit.show=true
    },
    initAssociationPost(associationId){
      return new Promise((resolve,reject)=>{
        fetchAssociationThreadList({
          where:JSON.stringify({
            association_id:associationId
          }),
          preload:true
        }).then(res=>{
          this.AssociationPosts=res.data.lists
          resolve(res)
        })
      })
    },
    initAssociation(){
      return new Promise((resolve,reject)=>{
        fetchAssociationList({
          where:JSON.stringify({
            user_id:this.$store.getters.getUser.infoUserUid
          })
        }).then(res=>{
          this.AssociationList=res.data.lists
          resolve(res)
        })
      })
    }
  },
  created() {
    this.initData()
  },
  data(){
    return{
      AssociationList:[],
      AssociationPosts:[],
      StationEdit:{
        isCreate:0,
        stationId:0,
        show:false
      }
    }
  }
}
</script>

<style slot-scope lang="scss">
.axj-station{

}
</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-station/index.vue